import React, { useEffect } from "react";
import { connect, useSelector, useDispatch } from "react-redux";
import Dots from "react-activity/lib/Dots";
import "react-activity/lib/Dots/Dots.css";
import Home from "./pages/Home";

import { View } from "react-native-web";
import Login from "./pages/Login";
import { AuthContext } from "../shared/core/context";
import { validatePatientTokenFromApi } from "../shared/actions/TokenValidActions";
import getUserId from "../shared/core/GetToken";

import Appointments from "./pages/Appointments";
import Diagnosis from "./pages/Diagnosis";
import Med from "./pages/Med";
import PatientResults from "./pages/PatientResults";
import AllergiesHome from "./pages/AllergiesHome";
import ImmuneHome from "./pages/ImmuneHome";
import TimelineHome from "./pages/TimelineHome";
import RemidersHome from "./pages/RemidersHome";
import ResourcesHome from "./pages/ResourcesHome";
import ForgetPassword from "./pages/ForgetPassword";
import LettersDocs from "./pages/LettersDocs";
import Vitals from "./pages/Vitals";
import ResetPassword from "./pages/ResetPassword";
import Messaing from "./pages/Messaing";
import UserProfile from "./pages/UserProfile";

import PrivateRoute from "./PrivateRoute";
import PublicRoute from "./PublicRoute";
import OuterHtml from "./components/OutterHtml";
import useGoogleAnalytics from "./hooks/useGoogleAnalytics";
import MyCareTeam from "./pages/MyCareTeam";
import ReadMessage from "./components/ReadMessage";
import ReactGA from "react-ga";
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";
import ServiceTemplate from "./pages/ServiceTemplate";
import { appServices } from "../shared/redux/actions/appServices";
import getUserInfo from "../shared/core/GetTokenized";

import { BrowserRouter as Router, Routes, Route, useNavigate, BrowserRouter } from "react-router-dom";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBVlxD9uptxI7bHJbLPIQqCbA1ypc8jdfg",
  authDomain: "myindici-ireland.firebaseapp.com",
  projectId: "myindici-ireland",
  storageBucket: "myindici-ireland.appspot.com",
  messagingSenderId: "91561741352",
  appId: "1:91561741352:web:21b94d5514a6f76cd4791d",
  measurementId: "G-NGMTNSJ7E4",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const firebaseAnalytics = getAnalytics(app);

const GA_MEASUREMENT_ID = "G-NGMTNSJ7E4";

ReactGA.initialize(GA_MEASUREMENT_ID);
const Main = (props) => {
  useGoogleAnalytics();
  
  const information = getUserInfo(); // Get the user info (will resolve the promise)
  const PatienInformation = JSON.parse(information);
  console.log(PatienInformation, "item23");

  const [userToken, setUserToken] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(true);
  const dispatch = useDispatch();
  
  const { TokenValidator, isChecking, error } = useSelector(
    (state) => state.validateToken
  );
  // const linkHistory = useNavigate();

  useEffect(() => {
    ReactGA.pageview(window.location.pathname);
  }, [window.location.pathname]);

  useEffect(() => {
    console.log(PatienInformation, "pppp");
    if (PatienInformation) {
      dispatch(
        appServices.ValidateToken({
          PatientID: PatienInformation.parentid || "abc",
        })
      );
    }
  }, []);

  const authContext = React.useMemo(() => {
    return {
      signIn: () => {
        setUserToken("asdf");
      },
      signOut: () => {
        setUserToken(null);
      },
    };
  });

  return (
    <AuthContext.Provider value={authContext}>
      {isChecking && (
        <View
          style={{
            opacity: 1,
            position: "relative",
            backgroundColor: "#fff",
            flex: 1,
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Dots />
        </View>
      )}
      {!isChecking && (
      
          <Routes>
            <Route path="/login" element={<PublicRoute component={Login} authed={TokenValidator} />} />
            <Route path="/forgetPassword" element={<PublicRoute component={ForgetPassword} authed={TokenValidator} />} />
            <Route path="/resetpassword" element={<PublicRoute component={ResetPassword} authed={TokenValidator} />} />

            <Route path="/preview" element={<PrivateRoute component={OuterHtml} authed={TokenValidator} />} />
            <Route path="/" element={<PrivateRoute component={Home} authed={TokenValidator} />} />
            <Route path="/appointments" element={<PrivateRoute component={Appointments} authed={TokenValidator} />} />
            <Route path="/diagnosis" element={<PrivateRoute component={Diagnosis} authed={TokenValidator} />} />
            <Route path="/medications" element={<PrivateRoute component={Med} authed={TokenValidator} />} />
            <Route path="/reports" element={<PrivateRoute component={PatientResults} authed={TokenValidator} />} />
            <Route path="/allergies" element={<PrivateRoute component={AllergiesHome} authed={TokenValidator} />} />
            <Route path="/immunisation" element={<PrivateRoute component={ImmuneHome} authed={TokenValidator} />} />
            <Route path="/timeline" element={<PrivateRoute component={TimelineHome} authed={TokenValidator} />} />
            <Route path="/reminders" element={<PrivateRoute component={RemidersHome} authed={TokenValidator} />} />
            <Route path="/resources" element={<PrivateRoute component={ResourcesHome} authed={TokenValidator} />} />
            <Route path="/letters" element={<PrivateRoute component={LettersDocs} authed={TokenValidator} />} />
            <Route path="/servicetemplate" element={<PrivateRoute component={ServiceTemplate} authed={TokenValidator} />} />
            <Route path="/vitals" element={<PrivateRoute component={Vitals} authed={TokenValidator} />} />
            <Route path="/emails" element={<PrivateRoute component={Messaing} authed={TokenValidator} />} />
            <Route path="/profile" element={<PrivateRoute component={UserProfile} authed={TokenValidator} />} />
            <Route path="/myCareTeam" element={<PrivateRoute component={MyCareTeam} authed={TokenValidator} />} />
            <Route path="/read" element={<PrivateRoute component={ReadMessage} authed={TokenValidator} />} />
          </Routes>
      )}
    </AuthContext.Provider>
  );
};

export default Main;
